export default "__VITE_ASSET__039dc23a__"